import React from "react";
import ReactDOM from "react-dom";
import "./scss/styles.scss";
import { BASE_URL } from "./config.json";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import AppHOC from "./components/pages/RenewMembership/AppHOC";

axios.defaults.baseURL = `${BASE_URL}/`;

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <AppHOC />
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root")
);

reportWebVitals();
